import { Questionary, RiskKeyType } from './types';

export function getYAxisLabels(type: Questionary) {
  const labels = {
    gad: [
      'ASSESSMENTRESULTS.SCALE.MINIMUM',
      'ASSESSMENTRESULTS.SCALE.LOW',
      'ASSESSMENTRESULTS.SCALE.MODERATE',
      'ASSESSMENTRESULTS.SCALE.HIGH',
    ],
    phq: [
      'ASSESSMENTRESULTS.SCALE.MINIMUM',
      'ASSESSMENTRESULTS.SCALE.LOW',
      'ASSESSMENTRESULTS.SCALE.MODERATE',
      'ASSESSMENTRESULTS.SCALE.MODERATELYHIGH',
      'ASSESSMENTRESULTS.SCALE.HIGH',
    ],
    who: [
      'ASSESSMENTRESULTS.SCALE.VERYLOW',
      'ASSESSMENTRESULTS.SCALE.LOW',
      'ASSESSMENTRESULTS.SCALE.HIGH',
      'ASSESSMENTRESULTS.SCALE.VERYHIGH',
    ],
  };

  return labels[type];
}

const riskLevelDetails: RiskKeyType = {
  who: {
    VERY_HIGH: {
      level: 3,
    },
    HIGH: {
      level: 2,
    },
    LOW: {
      level: 1,
    },
    VERY_LOW: {
      level: 0,
    },
  },
  phq: {
    SEVERE: {
      level: 4,
    },
    'MODERATE-SEVERE': {
      level: 3,
    },
    MODERATE: {
      level: 2,
    },
    MILD: {
      level: 1,
    },
    MINIMAL: {
      level: 0,
    },
  },
  gad: {
    SEVERE: {
      level: 3,
    },
    MODERATE: {
      level: 2,
    },
    MILD: {
      level: 1,
    },
    MINIMAL: {
      level: 0,
    },
  },
};

export function getRiskLevel(type: Questionary) {
  return riskLevelDetails[type];
}
